<template>
    <v-view :tableData="tableData"
            :tableProps="tableProps"
            :modalProps="modalProps"
            :columns="columns"
            :routes="routes"
            :initialSort="initialSort"
            :buttonsVisibility="buttonsVisibility"
            :rowButtonAction="rowButtonAction"
            v-model:selectedRows="selectedRows">

        <template #crud="formProps">
            <StatusForm :formProps="formProps">
            </StatusForm>
        </template>
        <template #search="searchProps">
            <StatusSearch :searchProps="searchProps">
            </StatusSearch>
        </template>

    </v-view>
</template>

<script setup>
import StatusForm from './StatusForm.vue'
import StatusSearch from './StatusSearch.vue'
import { ref } from "vue";
import { rowButtonAction } from '@pages/Helper/crud_utils.js'

const selectedRows = ref([])

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
    buttonsVisibility: Object,
})

//----------------------------------------------------------------

</script>

<style lang="scss"
       scoped></style>
